<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import { Cog, Icon } from 'svelte-hero-icons'

    import IconBell from '../Common/Icons/IconBell.svelte'

	// import { goto } from '$app/navigation'

	const dispatch = createEventDispatcher()

	const goSettings = () => dispatch('go_Settings')
</script>

<ul class="modeless-box-list">
	<li class="flex justify-center align-middle">
		<IconBell />
	</li>
	<li class="text-center">
		<p class="text-xl text-gray-800">¡You do not have any notifications!</p>
		<p class="text-gray-600 m-4">
			Check your settings
			<button class="text-gray-400 hover:text-gray-500 align-bottom" on:click={goSettings}>
				<Icon src={Cog} class="h-6 w-6" />
			</button>
			to set which notifications you want to receive.
		</p>
	</li>
</ul>
